/**
 * ### タイマー
 */
export default class TimerUtil {
  /**
   * ### タイマーをセットする
   *
   * - 本メソッドに時間(msec)を渡してawaitで待つことでタイマーをはれる
   *
   * @param interval 待機時間(msec)
   */
  public setTimeout(interval: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, interval);
    });
  }
}
